import { GET_PERIODOS } from '../actions/Periodos';

const INITIAL_STATE = [];

export default function periodos(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_PERIODOS:
            return action.periodos
        default:
            return state;
    }
}